// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","primary":"#56CCF2","textDefault":"#808080","column":"CU_orGUKJ_tWm-6vldAuN","row":"_1tWNZZNZQWIRtEhPW67xOV","title":"Do7832rDBVJKgYxO-B7BZ","input":"_1Lu0FGVUGdNQagnhwwljeQ","label":"_1f5j1xiKXO0-umnMPvs_gl","circle":"_1BoC2yGgvn_2kAp27zaSi2","help-wrapper":"_107kZkDEk3c3GyTtz92yo0","error":"_2ResTvNXRIsXAnbLXlWfSp"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/ConnectedRadio.mod.css
// module id = 1716
// module chunks = 0